// Records the browser's IANA time zone (for example "America/Chicago") in a
// cookie so the server can render times in the viewer's zone; see
// ApplicationController#use_browser_time_zone. Runs on every page load and
// rewrites the cookie only when it is missing or stale, e.g. after travel.
(function () {
  try {
    const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!zone) return;

    const value = 'time_zone=' + encodeURIComponent(zone);
    const current = document.cookie.split('; ').find((c) => c.startsWith('time_zone='));
    if (current === value) return;

    let cookie = value + '; path=/; max-age=31536000; samesite=lax';
    if (window.location.protocol === 'https:') cookie += '; secure';
    document.cookie = cookie;
  } catch (e) {
    // No Intl support or cookies blocked: the server falls back to UTC.
  }
})();
